import PropTypes from 'prop-types';

function NetworkVisual({ t }) {
    return (
        <div className="network-visual" aria-hidden="true">
            <span className="network-ring ring-one" />
            <span className="network-ring ring-two" />
            <div className="network-node node-user"><i /><b>{t('diagramUser')}</b></div>
            <div className="network-node node-proxy"><i /><b>{t('diagramProxy')}</b></div>
            <div className="network-node node-web"><i /><b>{t('diagramWeb')}</b></div>
            <span className="route-line route-one" />
            <span className="route-line route-two" />
        </div>
    );
}

function ExplainerSection({ t }) {
    const difference = [
        t('difference.1'),
        t('difference.2'),
        t('difference.3'),
    ];

    return (
        <section className="explainer section-panel">
            <div className="content-width">
                <h2>{t('whatTitle')}</h2>
                <div className="explainer-grid">
                    <article><h3>{t('whatHeading')}</h3><p>{t('whatText')}</p></article>
                    <NetworkVisual t={t} />
                    <article><h3>{t('howHeading')}</h3><p>{t('howText')}</p></article>
                </div>
                <div className="difference">
                    <h3>{t('differenceTitle')}</h3>
                    <div className="difference-copy">{difference.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}</div>
                </div>
            </div>
        </section>
    );
}

NetworkVisual.propTypes = {
    t: PropTypes.func.isRequired,
};

ExplainerSection.propTypes = {
    t: PropTypes.func.isRequired,
};

export default ExplainerSection;
